module.exports = __webpack_public_path__ + "img/float-top-deco.c8b1867.webp";